module.exports = "<nav class=breadcrumb> <div class=breadcrumb-wrap> <a class=breadcrumb-item ui-sref=home translate>Home</a> <a class=breadcrumb-item ui-sref=general.outlet translate>Outlet</a> <b class=breadcrumb-item><translate>{{::vm.category.name}}</translate></b> </div> </nav> <h1>{{ ::vm.category.name }}</h1> <outlet-product-overview filter-categories=vm.categories on-filter-change=vm.onFilterChange() context=seller-products-overview model=vm.productOverviewModel parent-state=vm.parentState></outlet-product-overview>";


//////////////////
// WEBPACK FOOTER
// ./features/outlet/outlet-products.html
// module id = 616
// module chunks = 0